import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "d-flex flex-column",
    style: { "min-height": "600px" }
};
const _hoisted_2 = {
    class: "sticky-top bg-white",
    style: { "padding-top": "20px" }
};
const _hoisted_3 = { class: "nav nav-tabs" };
const _hoisted_4 = { class: "nav-item" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
    class: "border border-top-0 p-3",
    style: { "flex": "1" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_document_fields = _resolveComponent("g-document-fields");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, {
        title: _ctx.document?.caption,
        "class-content": "content__for-sticky"
    }, {
        "modal-footer": _withCtx(() => [
            _createVNode(_component_g_button, {
                text: _ctx.$tc('shared.Text.Close'),
                onClick: _ctx.currentWindow.close,
                type: "normal",
                class: "w-120-px"
            }, null, 8, ["text", "onClick"])
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                (_ctx.document)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("ul", _hoisted_3, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.document.sections, (section, index) => {
                                    return (_openBlock(), _createElementBlock("li", _hoisted_4, [
                                        _createElementVNode("a", {
                                            class: _normalizeClass(["nav-link", { active: _ctx.activeItem === index }]),
                                            onClick: _withModifiers(($event) => (_ctx.setActive(index)), ["prevent"]),
                                            href: "#home"
                                        }, _toDisplayString(section.caption), 11, _hoisted_5)
                                    ]));
                                }), 256))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_g_document_fields, {
                                fields: _ctx.document.sections[_ctx.activeItem].fields,
                                "row-classes": "py-1"
                            }, null, 8, ["fields"])
                        ])
                    ], 64))
                    : _createCommentVNode("", true)
            ])
        ]),
        _: 1
    }, 8, ["title"]));
}
